import moment from "moment";

/**
 * Normalize API date values (ISO string, [y,m,d], or moment-parsable string) for display.
 */
export function parseDpatAssessmentDate(value) {
  if (value == null || value === "") return null;
  if (Array.isArray(value) && value.length >= 3) {
    const [y, m, d] = value;
    const dt = moment({ year: y, month: (m || 1) - 1, day: d || 1 });
    return dt.isValid() ? dt : null;
  }
  const dt = moment(value);
  return dt.isValid() ? dt : null;
}

export function formatDpatAssessmentDate(value, format = "MMMM D, YYYY") {
  const dt = parseDpatAssessmentDate(value);
  return dt ? dt.format(format) : null;
}

/**
 * Label + value for the assessment header row.
 */
export function getDpatAssessmentDateDisplay(assessmentStatus) {
  if (!assessmentStatus) {
    return { label: "Date of Assessment", value: "—", secondary: null };
  }

  const status = String(assessmentStatus.status || "").toLowerCase();
  const started = formatDpatAssessmentDate(assessmentStatus.assessmentStartDate);
  const closed =
    formatDpatAssessmentDate(assessmentStatus.closedDate) ||
    formatDpatAssessmentDate(assessmentStatus.assessmentEndDate);

  if (status === "closed" || status === "completed") {
    return {
      label: status === "closed" ? "Assessment closed" : "Assessment completed",
      value: closed || started || "—",
      secondary: started ? `Started ${started}` : null,
    };
  }

  return {
    label: "Assessment started",
    value: started || "—",
    secondary: null,
  };
}
